var CartDrawer = CartDrawer || {};
CartDrawer = {
  init: function() {
    this.initAddToCart();
    this.initPlus();
    this.initMinus();
    this.initUpdateQty();
    this.initRemoveItemCart();
    this.closeCartDrawer();
    this.openCartDrawer();
  },

  openCartDrawer: () => {
    $('body').on('click', '.ajax-cart__toggle', function(e) {
      e.preventDefault();
      $.get('/cart?view=drawer', function(data) {
        $('body').addClass('open-cart-drawer');
        $('.js-cart-drawer').html(data);
        $('html').addClass('no-scroll');
      });
    });
  },

  ajaxAddToCart: (productItem) => {
    const message = $('.product-message');
    $.post('/cart/add.js', productItem.serialize(), null, 'json').done(function (data) {
      message.fadeOut(300);
      var cart = data;
      $.get('/cart?view=drawer', function(data) {
        $('body').addClass('open-cart-drawer');
        $('.js-cart-drawer').html(data);
        $('.ats_cart_force_count').text(`(${cart.quantity})`);
        
      });
    }).fail(function ({ responseJSON }) {
      const { description } = responseJSON;
      message.html(description).fadeIn(300);
    });
  },

  initAddToCart() {
    $('body').on('click', '.ajax-add-to-cart', function(e) {
      e.preventDefault();
      const productItem = $(this).parents('form[action="/cart/add"]');
      CartDrawer.ajaxAddToCart(productItem);
    })
  },

  updateCart(qty, id) {
    $.post('/cart/change.json', {
      quantity: qty,
      id: id
    }).done(function(cart) {
      $.get('/cart?view=drawer', function(data) {
        $('.js-cart-drawer').html(data);
      });
      $('.js-mini-cart-count').text(cart.item_count);
      $('.ats_cart_force_count').text(`(${cart.item_count})`);
      if(qty == '') {
        $(this).val(1);
      }
    });
  },

  initPlus() {
    $('body').on('click', '.cart__btn-plus', function() {
      let item = $(this).parents('.mini-cart__item'),
          id = item.attr('data-id'),
          quantity = item.find('.mini-cart__qty-input').val(),
          number = parseFloat(quantity) + 1;

          item.find('.mini-cart__qty-input').val(number);
      let qty = item.find('.mini-cart__qty-input').val();
      CartDrawer.updateCart(qty, id);
    });
  },

  initMinus() {
    $('body').on('click', '.cart__btn-minus', function() {
      let item = $(this).parents('.mini-cart__item'),
          id = item.attr('data-id'),
          quantity = item.find('.mini-cart__qty-input').val(),
          number = parseFloat(quantity) - 1;

      if (quantity >= 2) {
        item.find('.mini-cart__qty-input').val(number);
      }

      let qty = item.find('.mini-cart__qty-input').val();
      CartDrawer.updateCart(qty, id);
    })
  },

  initUpdateQty() {
    $('body').on('focusout', '.mini-cart__qty-input', function() {
      let id = $(this).attr('data-cart-id'),
          qty = $(this).val();
      CartDrawer.updateCart(qty, id);
    });
  },

  initRemoveItemCart() {
    $('body').on('click', '.js-remove-item-cart', function(e) {
      e.preventDefault();
      const item = $(this).parents('.mini-cart__item'),
            id = item.attr('data-id'),
            qty = 0;
      CartDrawer.updateCart(qty, id);
    })
  },

  closeCartDrawer() {
    $('body').click(function(event) {
      if (!$(event.target).closest('.js-cart-drawer').length && !$(event.target).is('.js-cart-drawer') && !$(event.target).closest('.header__mini-cart').length) {
         $('body').removeClass('open-cart-drawer');
        $('html').removeClass('no-scroll');
      }
    });

    $('body').on('click', '.js-close-minicart', function() {
      $('body').removeClass('open-cart-drawer');
      $('html').removeClass('no-scroll');
    })
  }
}

$(function() {
  CartDrawer.init();
})